class MasonryNavigation extends HTMLElement {
    constructor() {
        super();

        const originalThis = this;

        this.closeText = window.masonryNavigation.close ? window.masonryNavigation.close : 'Close';
        this.toggle = this.querySelector('.masonry-navigation__open');
        this.toggleSpan = this.querySelector('.masonry-navigation__fixed-button span');
        this.defaultToggleText = this.toggleSpan?.textContent;

        if (this.toggle) {
            this.toggle.addEventListener('click', () => {
                if (this.toggleSpan && this.toggleSpan.textContent === this.defaultToggleText) {
                    this.toggle.classList.add('open');
                    document.getElementById('PopupModal-masonry').show();
                } else {
                    this.toggle.classList.remove('open');
                    document.getElementById('PopupModal-masonry').hide();
                }
            });
        }

        this.previewContentButton = this.querySelectorAll('.masonry-navigation__item-button');
        this.previewContentButton.forEach((button) => {
            button.addEventListener('click', this.togglePreview.bind(button));
        });

        document.addEventListener('modal:close', (event) => {
            const { modal } = event.detail;
            if (modal.getAttribute('id') === 'PopupModal-masonry') {
                originalThis.setOpenText();
            }
        });

        document.addEventListener('modal:open', (event) => {
            const { modal } = event.detail;
            if (modal.getAttribute('id') === 'PopupModal-masonry') {
                originalThis.setCloseText();
            }
        });
    }

    setCloseText() {
        this.toggleSpan.innerHTML = this.closeText;
    }

    setOpenText() {
        this.toggleSpan.innerHTML = this.defaultToggleText;
    }

    togglePreview(event) {
        const button = event.target;
        if (!button.classList.contains('masonry-navigation__item-button')) return;

        event.preventDefault();
        const buttonLink = button.dataset.link;
        const navItem = event.target.closest('.masonry-navigation__menu-item');
        navItem
            .querySelector('.masonry-navigation__menu-item-image')
            .classList.add('masonry-navigation__menu-item-image--hidden');
        navItem
            .querySelector('.masonry-navigation__menu-item-content')
            .classList.add('masonry-navigation__menu-item-content--preview-open');
        navItem
            .querySelector('.masonry-navigation__item-preview-content')
            .classList.add('masonry-navigation__item-preview-content--active');
        button.setAttribute('href', buttonLink);
        button.classList.remove('masonry-navigation__item-button');
    }
}

customElements.define('masonry-navigation', MasonryNavigation);
